import { render, staticRenderFns } from "./ModalRegistrarComprobanteReversion.vue?vue&type=template&id=2139135c&scoped=true"
import script from "./ModalRegistrarComprobanteReversion.vue?vue&type=script&lang=js"
export * from "./ModalRegistrarComprobanteReversion.vue?vue&type=script&lang=js"
import style0 from "./ModalRegistrarComprobanteReversion.vue?vue&type=style&index=0&id=2139135c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139135c",
  null
  
)

export default component.exports